import { getCurrencyFromCountry } from "./currency";
/**
 * Finds the balance amount for the organization's currency from a Stripe balance array.
 * Stripe returns balance arrays with entries per currency, and the order is not guaranteed.
 * This helper ensures we get the correct currency's balance instead of blindly using index [0].
 *
 * @param balanceArray - Array of balance objects with amount and currency
 * @param country - Organization country to determine the expected currency
 * @returns The balance amount for the organization's currency, or 0 if not found
 */
export const getBalanceAmountForCountry = (balanceArray, country) => {
    if (!balanceArray || balanceArray.length === 0) {
        return 0;
    }
    const expectedCurrency = getCurrencyFromCountry(country);
    const balanceEntry = balanceArray.find((b) => b.currency === expectedCurrency);
    // If we find a matching currency, use it; otherwise fall back to first entry for backwards compatibility
    return balanceEntry?.amount ?? balanceArray[0]?.amount ?? 0;
};
